import Col from "../../../components/element/col";
import Container from "../../../components/element/container";
import Icon from "../../../components/element/icon";
import Row from "../../../components/element/row";

export default function OrderShipping({ order }) {
  const shippingInfo = {
    name: order?.order_properties?.delivery_info?.fullName,
    contact: order?.order_properties?.delivery_info?.phone,
    address: `${order?.order_properties?.delivery_info?.address}, 
              ${order?.order_properties?.delivery_info?.city}, 
              ${order?.order_properties?.delivery_info?.zip} 
              ${order?.order_properties?.delivery_info?.state}, 
              ${order?.order_properties?.delivery_info?.country}`,
    delivery_instruction:
      order?.order_properties?.delivery_info?.deliveryInstructions,
  };

  const shippingList = [
    { label: "Name", value: "name" },
    { label: "Contact No.", value: "contact" },
    { label: "Full Address", value: "address" },
    { label: "Delivery Instruction", value: "delivery_instruction" },
  ];

  return (
    <Container tag="article" className="order-shipping">
      <Col className="v-flex gap-4">
        <h4 className="_label shipping-title">Shipping Information</h4>
        <Col className="v-flex gap-3 mt-2">
          {shippingList.map(
            (shipping, shippingIndex) =>
              shippingInfo[shipping.value] && (
                <p key={shippingIndex} className="_label shipping-label">
                  {shipping.label}:&nbsp;&nbsp;
                  <span>{shippingInfo[shipping.value]}</span>
                </p>
              )
          )}
        </Col>
      </Col>
    </Container>
  );
}
